<app-loading #loading></app-loading>
<app-mobile-login (onSave)="authenticateUser($event)"> </app-mobile-login>
